import { createSelector } from "reselect";
import { RootState } from "store";
import AccountFeatures from "types/AccountFeatures";

export const selectCurrentUser = (state:RootState) => state.currentUser.me;
export const selectLoading = (state:RootState) => state.currentUser.loading;

export const selectAiProvider = createSelector(
  [ selectCurrentUser ],
  (currentUser) => currentUser?.account?.aiProvider || null
);

export const selectBetaQuestionsFeatureEnable = createSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.account?.features?.includes(AccountFeatures.BetaQuestions)
);

export const selectEventsFeatureEnable = createSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.account?.features?.includes(AccountFeatures.Events)
);

export const selectAIModuleFeatureEnable = createSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.account?.features?.includes(AccountFeatures.AIModule)
);
